var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgConnectedApps = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  transform: "translate(4 2)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M9 3.0007C9 1.8967 8.104 1.0007 7 1.0007 5.896 1.0007 5 1.8967 5 3.0007 5 4.1047 5.896 5.0007 7 5.0007 8.104 5.0007 9 4.1047 9 3.0007zM12.1973 6.0012C12.7083 5.1182 13.0003 4.0942 13.0003 3.0012 13.0003 1.9072 12.7083.8822 12.1973.0002M1.8027.0002C1.2917.8822.9997 1.9072.9997 3.0002.9997 4.0942 1.2917 5.1192 1.8027 6.0012"
}), /*#__PURE__*/React.createElement("line", {
  x1: 2,
  x2: 12,
  y1: 16.001,
  y2: 16.001,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 4,
  x2: 10,
  y1: 12.001,
  y2: 12.001,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1,18.0007 L5.198,9.1307 C5.522,8.4617 6.207,8.0007 7,8.0007 C7.793,8.0007 8.478,8.4617 8.802,9.1307 L13,18.0007"
}))));
export default SvgConnectedApps;